/* eslint-disable */
import moment from 'moment'
import _ from 'lodash'
import Vue from './hawa-component'

import { mapState, mapGetters } from 'vuex'

import { FindStacks, Stack, Parameter, Company, GetCompany } from '@/api/cems'
import { Tag } from '@/types/tag'
import { License } from '@/api/ping'

interface MapTag {
  [name: string]: Tag
}

interface MapParameter {
  [name: string]: Parameter
}

interface MapStack {
  stack: Stack
  parameters: MapParameter
}

export default Vue.extend({
  name: 'SVGTemplate',
  template: '<div></div>',
  data() {
    return {
      // moment: moment,
      company: new Company(),
      appName: 'Hawa',
      settings: {
        timeFormat: 'HH:mm:ss',
        dateFormat: 'DD MMMM YYYY',
      },
      internal: {
        timeString: '',
        dateString: '',
      },
      stacks: [{ stack: new Stack(), parameters: {} }] as MapStack[],
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isOperator', 'isStandarUser', 'isSuperAdmin']),
    ...mapState(['local', 'server', 'version', 'license', 'user']),
    tags(): MapTag {
      const tags: MapTag = {}
      for (const uid in this.$store.state.tag.items) {
        const tag: Tag = this.$store.state.tag.items[uid]
        tags[tag.name] = tag
      }

      return tags
    },
    licenseStatus(): string {
      if ((((this.license as unknown) as License).licenseId as string) == '') {
        return 'unlicensed'
      }

      return 'licensed'
    },
  },
  methods: {
    moment: moment,
    cyclic500ms() {
      if (this._isBeingDestroyed) {
        return
      }

      this.internal.timeString = moment().format(this.settings.timeFormat)
      this.internal.dateString = moment().format(this.settings.dateFormat)
      this.setRealtimeValue()

      this.parseHawaComponents()

      setTimeout(() => {
        this.cyclic500ms()
      }, 500)
    },

    cyclic1s() {
      if (this._isBeingDestroyed) {
        return
      }

      try {
        this.findStacks()
      } catch {
        //
      }

      setTimeout(() => {
        this.cyclic1s()
      }, 1000)
    },

    goto(path: string) {
      if (this.$route.path == path) {
        return
      }
      this.$router.push(path)
    },

    async openSVG(svgUID: string, ...stackName: string[]) {
      const route: { path?: string; query: any } = {
        query: { stack: stackName },
      }

      if (svgUID != '') {
        route.path = `/cems/svg/${svgUID}`
      }

      this.$router.push(route).catch((err: any) => {
        if (
          err &&
          typeof err.name == 'string' &&
          err.name == 'NavigationDuplicated'
        ) {
          return
        }
        throw err
      })
      //
    },

    async userLogout() {
      await (this as any).$store.dispatch('user/logout')
      ;(this as any).$router.push({ path: '/login' })
    },

    setRealtimeValue() {
      for (const ref in this.$refs) {
        const tagsCheck = ref.split('.')

        let target: any
        let precision = 0

        // contoh attribute:
        // ref = stacks[0].parameters.CO2
        // ref = stacks[0].parameters.CO2.value
        if (tagsCheck[0].includes('stacks[')) {
          if (tagsCheck[1].includes('parameters') && tagsCheck.length == 3) {
            const parameter: Parameter = _.get(this, ref, '####')
            if (
              typeof parameter == 'object' &&
              typeof parameter.value != 'undefined'
            ) {
              target = parameter.value
              precision = parameter.precision
            }
          } else {
            target = _.get(this, ref, '#####')
          }
        } else {
          target = _.get(this, ref, '#####')
        }

        if (typeof target == 'number') {
          const prec = (this as any).$refs[ref].getAttribute('precision')
          if (prec && prec != '') {
            try {
              precision = parseInt(prec)
            } catch {
              //
            }
          }

          if (precision != 0) {
            ;(this as any).$refs[ref].innerHTML = target.toFixed(precision)
            continue
          }
        }

        ;(this as any).$refs[ref].innerHTML = target
      }
    },

    async findStacks() {
      const stacksName = this.$route.query.stack

      let stacks = [] as Stack[]

      if (stacksName) {
        if (typeof stacksName == 'string') {
          stacks = await FindStacks(['Parameters'], [stacksName])
        } else if (Array.isArray(stacksName)) {
          stacks = await FindStacks(['Parameters'], stacksName as string[])
        }

        const stacksMap = {} as { [stackName: string]: MapStack }

        for (let indexStack = 0; indexStack < stacks.length; indexStack++) {
          const stack = stacks[indexStack]
          const stackMap = {
            parameters: {} as { [key: string]: Parameter },
            stack,
          }
          if (stack.parameters) {
            for (const parameter of stack.parameters) {
              stackMap.parameters[parameter.name] = parameter
            }
          }

          delete stackMap.stack.parameters
          stacksMap[stack.name] = stackMap
        }

        if (typeof stacksName == 'string') {
          if (this.stacks.length == 0) {
            this.stacks.push(stacksMap[stacksName])
          } else {
            this.stacks[0] = stacksMap[stacksName]
          }
        } else if (Array.isArray(stacksName)) {
          for (let indexName = 0; indexName < stacksName.length; indexName++) {
            const name = stacksName[indexName]
            if (!name) {
              continue
            }
            if (typeof this.stacks[indexName] == 'undefined') {
              this.stacks.push(stacksMap[name])
            } else {
              this.stacks[indexName] = stacksMap[name]
            }
          }
        }
      }
    },

    async getCompany() {
      this.company = await GetCompany()
    },
  },

  mounted() {
    this.getCompany()
    this.cyclic500ms()
    this.cyclic1s()
  },
})
